import { atom, AtomEffect, DefaultValue } from 'recoil';
import { localStoragePersisterEffect } from 'utils/recoilEffects';
import { OWNER_SCOPE } from './useOwnerScope';
import { STUDY_RELEVANCE } from './useStudyRelevance';
import type { TOwnerScope } from './useOwnerScope';
import type { TStudyRelevance } from './useStudyRelevance';
import { RightDrawerTab, type RightDrawerTabType } from './types';

export type RightDrawerFilterState = {
  activeTab: RightDrawerTabType;
  templateOwner: TOwnerScope;
  templateRelevance: TStudyRelevance;
  macroOwner: TOwnerScope;
  macroRelevance: TStudyRelevance;
  templateOrder: string;
  macroOrder: string;
};

export const DEFAULT_FILTER_STATE: RightDrawerFilterState = {
  activeTab: RightDrawerTab.Template,
  templateOwner: OWNER_SCOPE.All,
  templateRelevance: STUDY_RELEVANCE.All,
  macroOwner: OWNER_SCOPE.All,
  macroRelevance: STUDY_RELEVANCE.All,
  templateOrder: '-last_used_datetime,name',
  macroOrder: '-last_used_datetime,name',
};

// Backfill persisted v1 filter payloads with the new order fields, without forcing everyone’s filters to reset.
// order fields are added by RP-4625
const migrateOrderFieldsEffect: AtomEffect<RightDrawerFilterState> = ({ setSelf, trigger }) => {
  if (trigger !== 'get') return;
  // only run on initial hydration

  setSelf((currentValue) => {
    if (currentValue instanceof DefaultValue) return currentValue;

    const templateOrder = currentValue.templateOrder ?? DEFAULT_FILTER_STATE.templateOrder;
    const macroOrder = currentValue.macroOrder ?? DEFAULT_FILTER_STATE.macroOrder;

    // if values are already populated, just return current value (don't broadcast update)
    if (currentValue.templateOrder === templateOrder && currentValue.macroOrder === macroOrder) {
      return currentValue;
    }

    return { ...currentValue, templateOrder, macroOrder };
  });
};

export const rightDrawerFilterState = atom<RightDrawerFilterState>({
  key: 'rightDrawerFilterState',
  default: DEFAULT_FILTER_STATE,
  effects: [localStoragePersisterEffect({ version: 1 }), migrateOrderFieldsEffect],
});
